import { useState } from "react";
import { Button, Input } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { submitRejectionRevokeAction } from "src/services/invoice-api";

const InvoiceRejectionRevoke = ({
  onCloseModal,
  invoiceData,
  tab,
}: {
  onCloseModal: () => void;
  invoiceData: any;
  tab?: string;
}) => {
  const { toast } = useToast();
  const [referenceNumber, setReferenceNumber] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const { InvoiceFilters, InvoiceApprovalFilters } = useSelector((state: RootState) => state.invoice);
  const company_code =
    invoiceData?.company_code ??
    (tab === "entry"
      ? InvoiceFilters?.company?.[0]?.code
      : InvoiceApprovalFilters?.company?.[0]?.code);

  const siaId: number = invoiceData?.stockist_invoice_attachment_id;

  const handleRevoke = async () => {
    if (!referenceNumber.trim()) {
      toast({ description: "Reference number is required", variant: "destructive" });
      return;
    }
    setIsLoading(true);
    try {
      await submitRejectionRevokeAction(
        {
          stockist_invoice_attachment_id: siaId,
          revoke_remarks: referenceNumber.trim(),
        },
        company_code,
      );
      toast({ description: "Rejection revoked successfully", variant: "default" });
      onCloseModal();
    } catch (err: any) {
      toast({
        description: err?.response?.data?.message ?? "Failed to revoke rejection",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-y-3 w-[500px] mx-auto bg-white p-5 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-base font-semibold text-[#1B1A1F]">Revoke Rejection</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="close" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm text-[#666666]">
        Enter a reference number to revoke the rejection on this invoice.
      </p>

      <div>
        <p className="text-sm text-[#333] mb-1">Reference Number</p>
        <Input
          className="w-full"
          placeholder="Enter reference number"
          value={referenceNumber}
          onChange={(e) => setReferenceNumber(e.target.value)}
        />
      </div>

      <div className="flex justify-end gap-x-2 mt-2">
        <Button disabled={isLoading} className="bg-[#f5f5f5]" onClick={onCloseModal}>
          Cancel
        </Button>
        <Button
          isLoading={isLoading}
          loaderSize="small"
          disabled={isLoading || !referenceNumber.trim()}
          className="text-white bg-[#8051FF]"
          onClick={handleRevoke}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default InvoiceRejectionRevoke;
